import { LoggedOutHomepage } from '@fiverr-private/header/';

export default LoggedOutHomepage;
